import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';

@Component({
  selector: 'app-symptom-checker-popup',
  templateUrl: 'symptom-checker-popup.component.html',
  styleUrls: ['symptom-checker-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [
    CommonModule,
    IonicModule,
  ]
})
export class SymptomCheckerPopupComponent {
  @Input() title: string = '';
  @Input() message: string = '';
  @Input() yesText: string = 'Yes';
  @Input() noText: string = 'No';
  @Input() okText: string = 'OK';
  @Input() mode: 'yes_no' | 'ok_only' = 'yes_no';

  constructor(private modalController: ModalController) {}

  /**
   * Dismiss the modal signalling the user answered "Yes".
   * Callers detect this via `modal.onWillDismiss()` -> `{ role: 'yes' }`.
   */
  dismissYes(): void {
    this.modalController.dismiss(null, 'yes');
  }

  /**
   * Dismiss the modal signalling the user answered "No".
   * Callers detect this via `modal.onWillDismiss()` -> `{ role: 'no' }`.
   * Backdrop click dismisses automatically with `role: 'backdrop'`
   * (Ionic default when `backdropDismiss: true`).
   */
  dismissNo(): void {
    this.modalController.dismiss(null, 'no');
  }

  /**
   * Dismiss the modal signalling the user acknowledged (OK-only mode).
   * Callers detect this via `modal.onWillDismiss()` -> `{ role: 'ok' }`.
   */
  dismissOk(): void {
    this.modalController.dismiss(null, 'ok');
  }
}
